var _classCallCheck = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/inherits");

// Generated by CoffeeScript 2.4.1
(function () {
  var NodeType, XMLCharacterData, XMLComment;
  NodeType = require('./NodeType');
  XMLCharacterData = require('./XMLCharacterData'); // Represents a comment node

  module.exports = XMLComment =
  /*#__PURE__*/
  function (_XMLCharacterData) {
    "use strict";

    _inherits(XMLComment, _XMLCharacterData);

    // Initializes a new instance of `XMLComment`
    // `text` comment text
    function XMLComment(parent, text) {
      var _this;

      _classCallCheck(this, XMLComment);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(XMLComment).call(this, parent));

      if (text == null) {
        throw new Error("Missing comment text. " + _this.debugInfo());
      }

      _this.name = "#comment";
      _this.type = NodeType.Comment;
      _this.value = _this.stringify.comment(text);
      return _this;
    } // Creates and returns a deep clone of `this`


    _createClass(XMLComment, [{
      key: "clone",
      value: function clone() {
        return Object.create(this);
      } // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print

    }, {
      key: "toString",
      value: function toString(options) {
        return this.options.writer.comment(this, this.options.writer.filterOptions(options));
      }
    }]);

    return XMLComment;
  }(XMLCharacterData);
}).call(this);